export default __webpack_public_path__ + "static/media/home-icon.cdf1728e.svg";